module.exports = __webpack_public_path__ + "static/media/PushtimargImage42.8ac758d9.jpg";